import * as echarts from "echarts/core";
import { LabelLayout } from "echarts/features";
import { SVGRenderer } from "echarts/renderers";
import { BarChart, LineChart, SankeyChart } from "echarts/charts";
import { useMemo, useContext, createContext } from "react";
import { GridComponent, TooltipComponent, TitleComponent, LegendPlainComponent } from "echarts/components";

// Register the required components
echarts.use([
  BarChart,
  LineChart,
  SankeyChart,
  SVGRenderer,
  LabelLayout,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendPlainComponent,
]);

// ChartContext to keep the latest state
const ChartContext = createContext(null);

// useChartContext to share this components state everywhere this component is imported
export const useChartContext = () => {
  const context = useContext(ChartContext);

  if (!context) throw new Error("useChartContext context must be use inside ChartProvider");

  return context;
};

export default function ChartProvider({ children }) {
  const memoizedValue = useMemo(() => ({ echarts }), []);

  return <ChartContext.Provider value={memoizedValue}>{children}</ChartContext.Provider>;
}
